const HOST = {
	development:'http://192.168.35.242:6699/',
	production:'http://douyin.adfancy.com.cn/'
}

export default {
  HOST : HOST[process.env.API_ENV]
}



// WEBPACK FOOTER //
// ./src/utils/config.js